import React, { Component } from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { Typography } from "@mui/material";

class MessageDetail extends Component {
  state = {};
  render() {
    const { open, onClose, content } = this.props;
    return (
      <div>
        <Dialog open={open} onClose={onClose}>
          <DialogTitle>نمایش پیام</DialogTitle>
          <DialogContent>
            <Typography variant="body2">
              {content.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </Typography>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default MessageDetail;
